module.exports = __webpack_public_path__ + "img/no-image-found.6060d5bd.png";